module.exports = __webpack_public_path__ + "img/120h100_s_fortochkoy_50h50_v_nizhnem_pravom_uglu.4e76db64.svg";